// removed by extract-text-webpack-plugin
module.exports = {"widget":"_2CanlWtQjNPU-kQMOvEkvS","content":"gIvSFGIJ24U-KtGNsX54a","title":"_1rrywDrMZ3jnyW5cXMt74u","countContainers":"_1yYVUx12U_SrXAD1v4yxBf","countContainer":"ePgMXorD97tsLu5k7iaRu","count":"_3ht3D9yQ0wQK6KH8z9ij4O","orders":"rgzqZYiki2Diyi8L0YAN_","orderContainer":"_2yq2NS1U5qolIr-2Ag3MhH","order":"QmDGvmrZr_IglDo3CIxhN","invoiceId":"_1322nksaLnnDM-E-gdE2MR","boxes":"qshmv57Kh2zjo0O3jwNEa","box":"_247YbU4PBImf8muQJR0d2C"};


//////////////////
// WEBPACK FOOTER
// ./app/widgets.new/PickQaStats/widget.scss
// module id = 1269
// module chunks = 0